import React from "react";
import HeaderThree from "../components/HeaderThree";
import FooterTwo from "../components/FooterThree";
import HowItWorksStep from "../components/HowItWorksStep";
import "../styles/how-it-works.scss";

const HowItWorks = () => {
  return (
    <>
      <HeaderThree />

      <main className="how-works-page">
        <HowItWorksStep />
      </main>

      <FooterTwo />
    </>
  );
};

export default HowItWorks;